// src/app/redux/reducers/formationsReducer.js

import {
    FETCH_FORMATIONS_REQUEST,
    FETCH_FORMATIONS_SUCCESS,
    FETCH_FORMATIONS_FAIL,

    CREATE_FORMATION_REQUEST,
    CREATE_FORMATION_SUCCESS,
    CREATE_FORMATION_FAIL,

    UPDATE_FORMATION_REQUEST,
    UPDATE_FORMATION_SUCCESS,
    UPDATE_FORMATION_FAIL,

    DELETE_FORMATION_REQUEST,
    DELETE_FORMATION_SUCCESS,
    DELETE_FORMATION_FAIL,

    DOWNLOAD_FORMATIONS_TEMPLATE_REQUEST,
    DOWNLOAD_FORMATIONS_TEMPLATE_SUCCESS,
    DOWNLOAD_FORMATIONS_TEMPLATE_FAIL,

    IMPORT_FORMATIONS_EXCEL_REQUEST,
    IMPORT_FORMATIONS_EXCEL_SUCCESS,
    IMPORT_FORMATIONS_EXCEL_FAIL,
    CLEAR_FORMATIONS_IMPORT_RESULT,

    EXPORT_FORMATIONS_REQUEST,
    EXPORT_FORMATIONS_SUCCESS,
    EXPORT_FORMATIONS_FAIL,

    SET_FORMATIONS_LOADING,
    SET_FORMATIONS_BULK_LOADING,
    CLEAR_FORMATIONS_ERROR, FETCH_FORMATIONS_BY_CATALOGUE_SUCCESS, FETCH_FORMATIONS_BY_CATALOGUE_FAIL,
} from "../actions/formationsActions";

const initialState = {
    list: [],
    loading: false,
    bulkLoading: false,
    error: null,

    // import review result
    importResult: null,
};

export default function formationsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_FORMATIONS_LOADING:
            return { ...state, loading: action.payload };

        case SET_FORMATIONS_BULK_LOADING:
            return { ...state, bulkLoading: action.payload };

        case CLEAR_FORMATIONS_ERROR:
            return { ...state, error: null };

        case CLEAR_FORMATIONS_IMPORT_RESULT:
            return { ...state, importResult: null };

        // CRUD
        case FETCH_FORMATIONS_REQUEST:
        case CREATE_FORMATION_REQUEST:
        case UPDATE_FORMATION_REQUEST:
        case DELETE_FORMATION_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_FORMATIONS_SUCCESS:
            return { ...state, loading: false, list: action.payload || [] };

        case CREATE_FORMATION_SUCCESS:
            return { ...state, loading: false, list: [...state.list, action.payload] };

        case UPDATE_FORMATION_SUCCESS:
            return {
                ...state,
                loading: false,
                list: state.list.map((f) => (f.id === action.payload.id ? action.payload : f)),
            };

        case DELETE_FORMATION_SUCCESS:
            return {
                ...state,
                loading: false,
                list: state.list.filter((f) => f.id !== action.payload.id),
            };

        case FETCH_FORMATIONS_FAIL:
        case CREATE_FORMATION_FAIL:
        case UPDATE_FORMATION_FAIL:
        case DELETE_FORMATION_FAIL:
            return { ...state, loading: false, error: action.error || "Erreur" };

        // Template / Export (no state needed except errors)
        case DOWNLOAD_FORMATIONS_TEMPLATE_REQUEST:
        case EXPORT_FORMATIONS_REQUEST:
            return { ...state, bulkLoading: true, error: null };

        case DOWNLOAD_FORMATIONS_TEMPLATE_SUCCESS:
        case EXPORT_FORMATIONS_SUCCESS:
            return { ...state, bulkLoading: false };

        case DOWNLOAD_FORMATIONS_TEMPLATE_FAIL:
        case EXPORT_FORMATIONS_FAIL:
            return { ...state, bulkLoading: false, error: action.error || "Erreur" };

        // Import review + execution (dryRun true/false)
        case IMPORT_FORMATIONS_EXCEL_REQUEST:
            return { ...state, bulkLoading: true, error: null, importResult: null };

        case IMPORT_FORMATIONS_EXCEL_SUCCESS:
            return { ...state, bulkLoading: false, importResult: action.payload || null };

        case FETCH_FORMATIONS_BY_CATALOGUE_SUCCESS:
            return { ...state, list: action.payload, loading: false, error: null };

        case FETCH_FORMATIONS_BY_CATALOGUE_FAIL:
            return { ...state, loading: false, error: action.payload };

        case IMPORT_FORMATIONS_EXCEL_FAIL:
            return { ...state, bulkLoading: false, error: action.error || "Erreur import Excel" };

        default:
            return state;
    }


}
